import { s as t, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as a, c as d } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var i = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.845 12.073 16 16 28.713 3.327c1.927 2.065 2.454 4.582 2.454 4.582.334 1.386.55 2.79.678 4.164Zm-3.134 16.599L16 16l15.83 3.923a31.778 31.778 0 0 1-.697 4.201s-.52 2.49-2.422 4.548ZM3.312 3.302 16 15.95.175 12.028a31.72 31.72 0 0 1 .691-4.153s.525-2.51 2.446-4.573ZM.158 19.926 16 16 3.288 28.672C1.387 26.613.866 24.124.866 24.124a28.651 28.651 0 0 1-.708-4.198Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M7.218.945c1.59-.443 3.787-.727 6.13-.86L16 16 7.218.945Zm6.13 30.969c-2.342-.132-4.54-.416-6.13-.86L15.988 16l-2.64 15.914ZM18.652.086c2.33.133 4.518.418 6.122.873L16 16 18.652.086Zm6.125 30.98c-1.592.454-3.791.727-6.135.853L16 16l8.777 15.066Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M20.667 16a4.667 4.667 0 1 0-9.334 0 4.667 4.667 0 0 0 9.334 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M20 16a4 4 0 1 0-8 0 4 4 0 0 0 8 0Z",
      clipRule: "evenodd"
    }
  )
), p = a(i)`
  ${t}
  ${d}
`, h = p;
export {
  h as default
};
